/* Tiny localStorage-backed "Recently viewed products" tracker for /services.
 *
 * - Stores up to 4 most-recent product views (newest first).
 * - Each entry is the minimum needed to render a card without a fetch:
 *   { slug, name, image, price, category, viewedAt }.
 * - All reads are SSR-safe (returns [] if window/localStorage is unavailable).
 */
const KEY = 'zhelta:services:recently-viewed';
const MAX = 4;

function safeStorage() {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function getRecentlyViewed() {
  const ls = safeStorage();
  if (!ls) return [];
  try {
    const raw = ls.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export function pushRecentlyViewed(product) {
  const ls = safeStorage();
  if (!ls || !product || !product.slug) return;
  const entry = {
    slug: product.slug,
    name: product.name,
    image: product.image,
    price: typeof product.price === 'number' ? product.price : null,
    category: product.category,
    viewedAt: Date.now(),
  };
  const current = getRecentlyViewed().filter((p) => p.slug !== entry.slug);
  const next = [entry, ...current].slice(0, MAX);
  try {
    ls.setItem(KEY, JSON.stringify(next));
  } catch {
    /* quota exceeded — silently drop */
  }
}
